// import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";

// const QualityChecksModal = ({ pointsSummary = {}, isModalOpen, toggle }) => {

  
//   const passedFailed = (value) => {
//     return {
//       label: value === 1 ? "Passed" : "Failed",
//       style: {
//         padding: "4px 10px",
//         borderRadius: "20px",
//         fontSize: "12px",
//         fontWeight: "600",
//         backgroundColor: value === 1 ? "#DCFCE7" : "#FEE2E2",
//         color: value === 1 ? "#166534" : "#991B1B",
//       },
//     };
//   };

//   const basePoints = Number(pointsSummary.basePoints && pointsSummary.basePoints ? 50: 0);
//   const qcPoints = Number(
//     pointsSummary.qualityChecks && pointsSummary.qualityChecks.pointsAwarded ? pointsSummary.qualityChecks.pointsAwarded : 0
//   );

//   const totalPoints = basePoints + qcPoints;

//   const attention = passedFailed(pointsSummary.qualityChecks?.attentionScore);
//   const time = passedFailed(pointsSummary.qualityChecks?.timeScore);
//   const profile = passedFailed(pointsSummary.qualityChecks?.profileScore);

//   const rowStyle = {
//     display: "flex",
//     justifyContent: "space-between",
//     alignItems: "center",
//     padding: "10px 12px",
//     borderRadius: "10px",
//     background: "#fff",
//     border: "1px solid #e5e7eb",
//     color: "#6b7280",
//   };

//   return (
//     <Modal isOpen={isModalOpen} toggle={toggle} centered>
      
//       <ModalHeader
//         toggle={toggle}
//         style={{
//           background: "#93D2FA",
//           color: "#fff",
//           borderBottom: "none",
//         }}
//       >
//         <div>
//           <div style={{ fontSize: "18px", fontWeight: "700" }}>
//             Points Summary
//           </div>
//           <div style={{ fontSize: "12px", opacity: 0.8 }}>
//             Points Calculation Breakdown
//           </div>
//         </div>
//       </ModalHeader>

//       <ModalBody style={{ background: "#f9fafb", padding: "16px" }}>
        
//         {/* TOTAL CARD */}
//         <div
//           style={{
//             background: "#fff",
//             borderRadius: "14px",
//             padding: "16px",
//             textAlign: "center",
//             marginBottom: "14px",
//             border: "1px solid #e5e7eb",
//           }}
//         >
//           <div style={{ fontSize: "12px", color: "#6b7280" }}>
//             Total Points
//           </div>
//           <div
//             style={{
//               fontSize: "32px",
//               fontWeight: "800",
//               margin: "5px 0",
//               color: "#000",
//             }}
//           >
//             {totalPoints}
//           </div>
//           {/* <div style={{ fontSize: "12px", color: "#6b7280" }}>
//             Base Points + Quality Check Points
//           </div> */}
//         </div>

//         {/* ROWS */}
//        {pointsSummary.qualityChecks && <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
          
//           <div style={rowStyle}>
//             <span>Base Points</span>
//             <strong>{basePoints}</strong>
//           </div>

//           <div style={rowStyle}>
//             <span>Attention Check</span>
//             <span style={attention.style}>{attention.label}</span>
//           </div>

//           <div style={rowStyle}>
//             <span>Time Check</span>
//             <span style={time.style}>{time.label}</span>
//           </div>

//           <div style={rowStyle}>
//             <span>Profile Check</span>
//             <span style={profile.style}>{profile.label}</span>
//           </div>

//           <div
//             style={{
//               ...rowStyle,
//               background: "#EEF2FF",
//               border: "1px solid #C7D2FE",
//             }}
//           >
//             <span>Quality Check Points</span>
//             <strong>{qcPoints}</strong>
//           </div>

//         </div>}
//       </ModalBody>

//       <ModalFooter style={{ borderTop: "none" }}>
//         <Button color="secondary" onClick={toggle}>
//           Close
//         </Button>
//       </ModalFooter>
//     </Modal>
//   );
// };

// export default QualityChecksModal;


import React from "react";
import { Modal, Button } from "reactstrap";
import coin from "../../../assets/images/coin.png";

const QualityChecksModal = ({ pointsSummary = {}, isModalOpen, toggle }) => {
  const basePoints = Number(pointsSummary.basePoints && pointsSummary.basePoints ? 50: 0);
  const qcPoints = Number(pointsSummary.qualityChecks && pointsSummary.qualityChecks.pointsAwarded ? pointsSummary.qualityChecks.pointsAwarded : 0)
  const totalPoints = basePoints + qcPoints;

  const statusPill = (value) => ({
    label: value === 1 ? "Pass" : "Fail",
    style: {
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      minWidth: "44px",
      padding: "4px 10px",
      borderRadius: "999px",
      fontSize: "12px",
      fontWeight: 400,
      backgroundColor: value === 1 ? "#DCFCE7" : "#FEE2E2",
      color: value === 1 ? "#166534" : "#DC2626",
    },
  });

  const attention = statusPill(pointsSummary && pointsSummary.qualityChecks && pointsSummary.qualityChecks.attentionScore);
  const time = statusPill(pointsSummary && pointsSummary.qualityChecks && pointsSummary.qualityChecks.timeScore);
  const profile = statusPill(pointsSummary && pointsSummary.qualityChecks && pointsSummary.qualityChecks.profileScore);

  const styles = {
    modalDialog: {
      maxWidth: "390px",
      width: "calc(100% - 24px)",
      margin: "12px auto",
    },
    shell: {
      background: "linear-gradient(180deg, #8ECDF7 0%, #CBE7FB 100%)",
      borderRadius: "20px",
      padding: "14px",
      boxShadow: "0 16px 40px rgba(0,0,0,0.18)",
      overflow: "hidden",
    },
    titleWrap: {
      padding: "2px 4px 12px 4px",
      color: "#111827",
    },
    title: {
      fontSize: "18px",
      fontWeight: 500,
      lineHeight: 1.1,
      marginBottom: "2px",
    },
    subtitle: {
      fontSize: "12px",
      opacity: 0.85,
      lineHeight: 1.2,
    },
    topCard: {
      background: "linear-gradient(180deg, #D9EEFF 0%, #CDE7FB 100%)",
      borderRadius: "14px",
      padding: "16px 14px 14px",
      textAlign: "center",
      marginBottom: "10px",
      border: "1px solid rgba(255,255,255,0.7)",
    },
    topLabel: {
      fontSize: "11px",
      letterSpacing: "1.8px",
      fontWeight: 700,
      color: "#6B7280",
      marginBottom: "8px",
    },
    coinRow: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "10px",
      marginBottom: "4px",
    },
    coin: {

      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
    },
    total: {
      fontSize: "44px",
      fontWeight: 600,
      lineHeight: 1,
      color: "#111827",
      letterSpacing: "-1px",
    },
    totalText: {
      fontSize: "14px",
      color: "#6B7280",
      marginTop: "8px",
      marginBottom: 0,
    },
    card: {
      background: "#FFFFFF",
      borderRadius: "12px",
      padding: "12px 14px",
      border: "1px solid rgba(229,231,235,0.95)",
      boxShadow: "0 1px 0 rgba(255,255,255,0.8) inset",
    },
    cardTitleRow: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: "12px",
      marginBottom: "2px",
    },
    cardTitle: {
      fontSize: "16px",
      fontWeight: 500,
      color: "#111827",
      lineHeight: 1.2,
    },
    cardSubtitle: {
      fontSize: "12px",
      color: "#6B7280",
      marginTop: "2px",
    },
    rightValue: {
      fontSize: "18px",
      fontWeight: 500,
      color: "#2563EB",
      lineHeight: 1,
      flexShrink: 0,
    },
    qcHeader: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      marginBottom: "8px",
    },
    divider: {
      borderTop: "1px dashed #E5E7EB",
      margin: "10px 0 10px",
    },
    qcRow: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "7px 0",
      fontSize: "14px",
      color: "#111827",
    },
    closeWrap: {
      display: "flex",
      justifyContent: "center",
      marginTop: "12px",
    },
    closeBtn: {
      minWidth: "120px",
      borderRadius: "999px",
      background: "#FFFFFF",
      border: "none",
      color: "#111827",
      fontWeight: 500,
      padding: "10px 20px",
      boxShadow: "0 2px 8px rgba(0,0,0,0.10)",
    },
  
  };

  const hasQC = Boolean(pointsSummary.qualityChecks);

  return (
    <Modal
      isOpen={isModalOpen}
      toggle={toggle}
      //centered
      fade
      style={styles.modalDialog}
      contentClassName="border-0 bg-transparent"
      backdropStyle={{ backgroundColor: "rgba(0,0,0,0.35)" }}
      //backdrop={true}
    >
      <div style={styles.shell}>
        <div style={styles.titleWrap}>
          <div style={styles.title}>Points Summary</div>
          <div style={styles.subtitle}>Quality checks breakdown</div>
        </div>

        <div style={styles.topCard}>
          <div style={styles.topLabel}>TOTAL POINTS EARNED</div>

          <div style={styles.coinRow}>
            <div style={styles.coin}>
              <img src={coin} style={{width:'40px', height: '38px'}}  alt="coin" />
            </div>
            <div style={styles.total}>{totalPoints}</div>
          </div>

          <p style={styles.totalText}>Base Points + Quality Check Points</p>
        </div>

        <div style={styles.card}>
          <div style={styles.cardTitleRow}>
            <div>
              <div style={styles.cardTitle}>Base Points</div>
              <div style={styles.cardSubtitle}>Survey completion reward</div>
            </div>
            <div style={styles.rightValue}>{basePoints}</div>
          </div>
        </div>

        {hasQC && (
          <div style={{ ...styles.card, marginTop: "8px" }}>
            <div style={styles.qcHeader}>
              <div>
                <div style={styles.cardTitle}>Quality Check Points</div>
                {/* <div style={styles.cardSubtitle}>Attention, time, and profile checks</div> */}
              </div>
              <div style={styles.rightValue}>{qcPoints}</div>
            </div>

            <div style={styles.divider} />

            <div style={styles.qcRow}>
              <span>Attention Check</span>
              <span style={attention.style}>{attention.label}</span>
            </div>

            <div style={styles.qcRow}>
              <span>Time Check</span>
              <span style={time.style}>{time.label}</span>
            </div>

            <div style={styles.qcRow}>
              <span>Profile Check</span>
              <span style={profile.style}>{profile.label}</span>
            </div>
          </div>
        )}

        <div style={styles.closeWrap}>
          <Button
            onClick={toggle}
            style={styles.closeBtn}
          >
            Close
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default QualityChecksModal;